// src/config.js
const config = {
    hostname: "https://www.fabmisr.com.eg",
  };
  export default config;
  